// React

// Libraries
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Utils

// MUI
import { Grid, Paper, Typography, useMediaQuery } from "@mui/material";
import { getTheme } from "../utils/theme";

// Custom Components

// Redux

// Services

const MainCard = (props) => {
  const isTablet = useMediaQuery(getTheme().breakpoints.down("tablet"));

  const { style, headTitle, showHomeIcon = true } = props;
  const params = useLocation();
  const { t } = useTranslation();

  const styles = {
    paper: {
      width: "stretch",
      // minHeight: '730px',
      boxShadow: "0px 0px 23px 2px rgba(0, 0, 0, 0.1)",
      borderRadius: "25px",
      border: "5px solid #ffffff",
      backgroundColor: "#F5F5F5",
      margin: isTablet ? "0.3rem" : "1rem",
      padding: isTablet ? "20px" : "50px",
    },

    ...style,
  };

  return (
    <Paper sx={{ ...styles.paper }}>
      <Grid container sx={{ ...styles.root }}>
        {props.children}
      </Grid>
    </Paper>
  );
};

export default MainCard;
